import { memo } from 'react';
import { OrderStatistics } from '@api/shipping-data/types/OrderStatistics';
import { useHasPermission } from '@hooks/has-permission/useHasPermission';
import { AppRolesEnum } from '@features/routing/appRolesEnum';
import { Grid } from '@pages/orders/detail/tabs-pages/basic-overview/material-grids/Grid';
import { getParsedUnversionedSystemId } from '@utils/getParsedSystemId';
import { useMaterialGridOrderClick } from '@pages/orders/detail/tabs-pages/basic-overview/material-grids/useMaterialGridOrderClick';



interface MaterialGridsProps {
	orders: OrderStatistics[],
	selectedOrderUnvId: string | null,
	saveNodeRefToOrdersMap: (node: HTMLDivElement | null, orderUnvId: string) => void,
}


export const MaterialGrids = (props: MaterialGridsProps) => {
	const { orders, selectedOrderUnvId, saveNodeRefToOrdersMap } = props;

	const materialGridOrderClick = useMaterialGridOrderClick();
	const hasPermission = useHasPermission();


	if (!orders || orders.length === 0) return (
		<div className='detail-material-grids'>
			<p className='detail-area-empty'>Žádná data k dispozici</p>
		</div>
	);
	
	return (
		<div className='detail-material-grids'>
			{orders.map(x =>
				<Grid
					orderStatistics={x}
					orderClientId={x.clientId}
					deliveryClientId={x.deliveryUnversionedSystemId ? getParsedUnversionedSystemId(x.deliveryUnversionedSystemId).clientId : null}
					shipmentClientId={x.shipmentUnversionedSystemId ? getParsedUnversionedSystemId(x.shipmentUnversionedSystemId).clientId : null}
					materials={x.itemsStats}
					isSameAsSelectedOrder={selectedOrderUnvId ? selectedOrderUnvId === x.unversionedSystemId : false}
					getMaterialGridOrder={() => materialGridOrderClick(x.unversionedSystemId)}
					hasClickPermission={hasPermission(AppRolesEnum.orders_Read)}
					ref={(node) => {
						saveNodeRefToOrdersMap(node, x.unversionedSystemId);
					}}
					key={`detail-material-grids-${x.systemId}`} />)}
		</div>
	)
}

export default memo(MaterialGrids);